/**
 * Support Dialog Store
 * Manages the state of the ContactSupportDialog including error prefilling
 */

import { create } from "zustand";
import type { ReportableError } from "@/types/error.types";

interface SupportDialogState {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Prefilled error data for reporting */
  prefillError: ReportableError | null;
}

interface SupportDialogStore extends SupportDialogState {
  /** Open the support dialog */
  open: () => void;
  /** Open the support dialog with a prefilled error */
  openWithError: (error: ReportableError) => void;
  /** Close the support dialog */
  close: () => void;
  /** Clear the prefilled error */
  clearPrefillError: () => void;
}

export const useSupportDialogStore = create<SupportDialogStore>((set) => ({
  isOpen: false,
  prefillError: null,

  open: () => set({ isOpen: true }),

  openWithError: (error: ReportableError) =>
    set({
      isOpen: true,
      prefillError: error,
    }),

  close: () => set({ isOpen: false }),

  clearPrefillError: () => set({ prefillError: null }),
}));
